<template>
  <tr class="transaction-item">
    <td class="text-left">
      <div class="source-type">
        <span class="transaction-date">{{ txDate }}</span> <span class="source">{{ source }}</span>
      </div>
      <span :class="['ics-tag', `is-${icsType}`]">{{ icsTagText }}</span>
      <span class="building-name">
        {{ name }}
      </span>
    </td>
    <td class="text-right" v-if="icsType === 's'">
      <div 
        v-for="(area, index) in area.zh"
        class="area-shop">
        <span class="area-desc">{{ area.desc }}</span>
        <span class="area-value">{{ fmt(area.value) }}</span>
        <span class="feet">{{ $t('transaction.SQFT') }}</span>
      </div>
      <div 
        v-if="area.zh.length === 0"
        class="area-shop">
        -
      </div>
    </td>
    <td class="text-right" v-else>
      <span class="area-value">{{ fmt(area.value) }}</span>
      <span class="feet">{{ $t('transaction.SQFT') }}</span>
    </td>
    <td class="text-center">
      <span class="tx-type" :class="[ txClass ]">
        {{ txType === 'S'? $t('transaction.SOLD') : $t('transaction.LEASED') }}
      </span>
    </td>
    <td class="text-right">
      <span class="price-feet-value">{{ priceFeet }}</span> / <span class="feet">{{ $t('transaction.SQFT') }}</span>
    </td>
    <td class="text-right"><span class="price-total-value">${{ priceTotal }}</span></td>
    <td class="text-right">
      <link-button 
        :icsType="icsType"
        :targetLink="stockLink"
        :buttonText="$t('transaction.RELATED_STOCK')"
        class="link-btn"
        v-if="stockSearchButton"
      />
    </td>
  </tr>
</template>

<script>
import numberFormat from '@/mixins/numberFormat';
import LinkButton from '@/components/LinkButton';

export default {
  props: [
    'txDate',
    'source',
    'name',
    'area',
    'icsType',
    'txType',
    'priceFeet',
    'priceTotal',
    'stockLink',
    'stockSearchButton',
  ],
  mixins: [numberFormat],
  components: {
    LinkButton,
  },
  computed: {
    txClass() {
      return this.txType === 'S' ? 'tx-type-sold' : 'tx-type-leased';
    },
    icsTagText() {
      let output = '';
      switch (this.icsType) {
        case 'i':
          output = this.$t('find.IND_SS');
          break;
        case 'c':
          output = this.$t('find.COMM_SS');
          break;
        case 's':
          output = this.$t('find.SHOP_SS');
          break;
        default:
          break;
      }
      return output;
    },
  },
};
</script>

<style scoped>
.transaction-item {
  border-bottom: 1px solid #EAEAEA;
}

.transaction-item td {
  padding: 4px 5px;
}

.transaction-item td:first-child {
  padding: 4px 5px 4px 15px;
}

.transaction-item td:last-child {
  padding: 4px 15px 4px 5px;
}

.transaction-date, .source, .tx-type {
  font-size: 1rem;
}
.building-name {
  font-size: 1.375rem;
  margin-right: 5px;
}
.tx-type {
  padding: 3px;
}
.tx-type-sold {
  color: #FF150D
}
.tx-type-leased {
  color: #00BEB5
}

.area-value, .price-feet-value, .price-total-value {  
  font-size: 1.5rem;
}

.area-desc {
  font-size: 20px;
}

.feet {
  font-size: 12px;
}

.link-btn {
  margin-top: 2px;
}

.ics-tag {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  color: #ffffff;
}

.ics-tag.is-i {
  background: #47337C;
  border-color: #47337C;
}

.ics-tag.is-c {
  background: #008CBA;
  border-color: #008CBA;
}

.ics-tag.is-s {
  background: #DA4E00;
  border-color: #DA4E00;
}

.source-type {
  color: #a8a086;
}

@media print {
  .stock-link-cell {
    display: none;
  }
  .text-right {
    text-align: right;
  }
  .text-left {
    text-align: left;
  }
  .text-center {
    text-align: center;
  }
}
</style>